import InfiniteScroll from 'react-infinite-scroll-component';
import { ImageInput } from './index';
import './style.scss';
import { IAsset } from '../../../page-builder/interface/apiServiceInterface';
import { DeleteIcon } from '../../../assets/icons/delete';
import './style.scss';
import SearchIcon from '@mui/icons-material/Search';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import PopUpModal from '../../../components/common/popup';
import Checkbox from '../../../components/common/checkbox';
import { Loader } from '../../../components/common/loader';
import { AxiosInstance } from 'axios';
import pageBuilderService from '../../../page-builder/api/pageBuilderService';
export interface Iprops {
  handleSubmit: (_selectedImage: IAsset) => void;
  setPopupOpen: (_open: boolean) => void;
  image: IAsset;
  isPopupOpen: boolean;
  customId?: string;
  baseService: AxiosInstance;
}
export type IpageSearch = {
  StoreID: number | null;
  Descending: boolean;
  Limit: number;
  OrderBy: string;
  Page: number;
  SearchFields: object;
};
const ImagePopup = ({
  handleSubmit,
  setPopupOpen,
  image,
  isPopupOpen,
  baseService,
  customId,
}: Iprops) => {
  const search: IpageSearch = {
    StoreID: null,
    Descending: false,
    Limit: 25,
    OrderBy: 'fileName',
    Page: 0,
    SearchFields: {},
  };
  const [pagesSearch, setPagesSearch] = useState<IpageSearch>(search);
  const [searchValue, setSearchValue] = useState('');
  const [hasMore, setHasMore] = useState<boolean>(true);
  const [defaultImageList, setDefaultImageList] = useState<IAsset[]>([]);
  const [selectedImage, setSelectedImage] = useState<IAsset>(image);
  const [imageList, setImageList] = useState<IAsset[]>([]);
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const storeID = searchParams.get('storeID') || '';
  const clientID = searchParams.get('clientID') || '';

  const handleSelection = () => {
    handleSubmit({
      ...selectedImage,
    });
    setPopupOpen(false);
  };
  const changeImageSelection = (
    event: React.ChangeEvent<HTMLInputElement>,
    image: IAsset,
  ) => {
    if (event.target.checked) {
      setSelectedImage(image);
    }
  };

  const getImageLists = async () => {
    try {
      setLoading(true);
      const response = await pageBuilderService.getAssets(
        {
          ...pagesSearch,
          StoreID: +storeID,
          ClientID: +clientID,
        },
        baseService,
      );
      setLoading(false);
      if (response?.status === 200 && response?.data?.Result) {
        setImageList(prev => [...prev, ...response.data.Result]);
        setDefaultImageList(prev => [...prev, ...response.data.Result]);
        if (response?.data?.TotalCount > pagesSearch.Limit * pagesSearch.Page) {
          setHasMore(false);
        }
      }
    } catch (error) {
      setLoading(false);
      console.error('ERROR IN getImageLists', error);
    }
  };

  const fetchMoreData = (): void => {
    if (hasMore) {
      setPagesSearch(prevPage => ({
        ...prevPage,
        Page: prevPage.Page + 1,
      }));
    }
  };

  const deleteImage = async (image: IAsset) => {
    try {
      const payLoad = {
        ID: image.code,
        StoreID: image.storeID,
        Filename: image.fileName,
      };
      setLoading(true);
      const response = await pageBuilderService.deleteAsset(
        payLoad,
        baseService,
      );
      setLoading(false);
      if (response.status === 200) {
        const updatedImageList = defaultImageList.filter(
          (img: IAsset) => img.code !== image?.code,
        );
        setDefaultImageList(updatedImageList);
        setImageList(updatedImageList);
      }
    } catch (error) {
      setLoading(false);
      console.error('ERROR IN deleteImage', error);
    }
  };

  useEffect(() => {
    getImageLists();
  }, [pagesSearch]);

  useEffect(() => {
    setImageList(
      defaultImageList.filter((image: IAsset) =>
        image.fileName?.toLowerCase().includes(searchValue.toLowerCase()),
      ),
    );
  }, [searchValue]);

  return (
    <PopUpModal
      open={isPopupOpen}
      handleClose={() => setPopupOpen(false)}
      customId={customId}
      buttons={[
        {
          buttonType: 'negative',
          buttonLabel: 'Cancel',
          buttonFunction: () => setPopupOpen(false),
        },
        {
          buttonType: 'positive',
          buttonLabel: 'Done',
          buttonFunction: handleSelection,
        },
      ]}
      heading={'Image Selector'}>
      <div className="popup-section !w-[100%] relative">
        <Loader loading={loading} />
        <div className=" flex justify-between items-center">
          <div className="bg-slate-400 flex items-center w-[40%] p-[4px] rounded-md mb-2">
            <SearchIcon className="text-gray-500" />
            <input
              className="!bg-transparent w-[40%] p-2 rounded-md border !border-none focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent font-medium"
              value={searchValue}
              placeholder="Search"
              onChange={e => {
                setSearchValue(
                  e.target.value.startsWith(' ')
                    ? e.target.value.trim()
                    : e.target.value,
                );
              }}
            />
          </div>
          <div>
            {selectedImage?.code && (
              <div>
                <button
                  className="bg-transparent text-red-500 border border-red-500 rounded-md px-2 py-1 mr-3 hover:bg-red-500 hover:text-white"
                  onClick={() => {
                    deleteImage(selectedImage);
                    setSelectedImage({
                      fileName: '',
                      imageUrl: '',
                      storeID: '',
                      code: '',
                    });
                  }}>
                  <DeleteIcon />
                </button>
              </div>
            )}
          </div>
        </div>
        <ImageInput
          setDefaultImageList={setDefaultImageList}
          storeID={storeID}
          clientID={clientID}
          baseService={baseService}
          setImageList={setImageList}
          setPagesSearch={setPagesSearch}
          setLoading={setLoading}
        />
        <div className="product-section-wrapper">
          {imageList?.length > 0 && (
            <InfiniteScroll
              dataLength={imageList.length}
              next={() => fetchMoreData()}
              hasMore={hasMore}
              scrollableTarget={customId ? customId : 'scrollableDiv'}
              loader={<></>}>
              <div className="image-selector-container">
                {imageList.map((image: IAsset, _index: number) => {
                  return (
                    <div
                      key={_index}
                      className="w-full p-1 hover:bg-slate-500 rounded cursor-pointer"
                      onClick={() => {
                        if (image?.code == selectedImage?.code) {
                          setSelectedImage({
                            fileName: '',
                            imageUrl: '',
                            storeID: '',
                            code: '',
                            width: '',
                            height: '',
                          });
                        } else {
                          setSelectedImage(image);
                        }
                      }}>
                      <div className="relative p-3">
                        <Checkbox
                          className="!absolute top-[14px] left-[14px] !p-0"
                          checked={
                            image?.code == selectedImage?.code ? true : false
                          }
                          onChange={event => changeImageSelection(event, image)}
                        />
                        {image?.imageUrl.includes('videos/') ? (
                          <video autoPlay controls={false} muted loop>
                            <source
                              src={`${process.env.REACT_APP_S3_BUCKET_URL}${image?.imageUrl}`}
                              type="video/mp4"
                            />
                          </video>
                        ) : (
                          <img
                            className="aspect-square object-cover rounded-md"
                            src={`${process.env.REACT_APP_S3_BUCKET_URL}${image?.imageUrl}`}
                          />
                        )}
                      </div>
                      <div className="font-12 whitespace-nowrap text-ellipsis overflow-hidden text-center pb-3">
                        {image.fileName}
                      </div>
                    </div>
                  );
                })}
              </div>
            </InfiniteScroll>
          )}
        </div>
      </div>
    </PopUpModal>
  );
};

export default ImagePopup;
